import { render, staticRenderFns } from "./SmileyRater.vue?vue&type=template&id=1f936c80&scoped=true&"
import script from "./SmileyRater.vue?vue&type=script&lang=js&"
export * from "./SmileyRater.vue?vue&type=script&lang=js&"
import style0 from "./SmileyRater.vue?vue&type=style&index=0&id=1f936c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f936c80",
  null
  
)

export default component.exports